const addToCartForms = document.querySelectorAll('form[action="/cart/add"][data-type="product-card-cart"]');
addToCartForms.forEach(form => {
    form.addEventListener('submit', async (event) => {
        event.preventDefault();
        try {
            // Show loading state
            form.querySelector('.custom-card-text').classList.add('hidden');
            form.querySelector('.loading__spinner').classList.remove('hidden');
            form.querySelector('.custom-card-button').classList.add('disabled');

            // Add to cart
            const response = await fetch("/cart/add", {
                method: "post",
                body: new FormData(form),
            });

            if (!response.ok) throw new Error('Failed to add to cart');

            // Update cart bubble
            window.dispatchEvent(new CustomEvent('cart-bubble-update'));

            // Open cart drawer and update it
            await window.dispatchEvent(new CustomEvent('update-cart-drawer'));
            window.dispatchEvent(new CustomEvent('open-cart-drawer'));

        } catch (error) {
            console.error('Error adding to cart:', error);
            // You might want to show an error message to the user here
        } finally {
            // Reset form state
            form.querySelector('.loading__spinner').classList.add('hidden');
            form.querySelector('.custom-card-text').classList.remove('hidden');
            form.querySelector('.custom-card-button').classList.remove('disabled');
        }
    });
});
// Function to attach event listeners to forms
function setupFormListeners() {
    const addToCartForms = document.querySelectorAll('form[action="/cart/add"][data-type="product-card-cart"]');
    addToCartForms.forEach(form => {
        form.addEventListener('submit', async (event) => {
            event.preventDefault();
            try {
                // Show loading state
                form.querySelector('.custom-card-text').classList.add('hidden');
                form.querySelector('.loading__spinner').classList.remove('hidden');
                form.querySelector('.custom-card-button').classList.add('disabled');

                // Add to cart
                const response = await fetch("/cart/add", {
                    method: "post",
                    body: new FormData(form),
                });

                if (!response.ok) throw new Error('Failed to add to cart');

                // Update cart bubble
                window.dispatchEvent(new CustomEvent('cart-bubble-update'));

                // Open cart drawer and update it
                await window.dispatchEvent(new CustomEvent('update-cart-drawer'));
                window.dispatchEvent(new CustomEvent('open-cart-drawer'));

            } catch (error) {
                console.error('Error adding to cart:', error);
                // You might want to show an error message to the user here
            } finally {
                // Reset form state
                form.querySelector('.loading__spinner').classList.add('hidden');
                form.querySelector('.custom-card-text').classList.remove('hidden');
                form.querySelector('.custom-card-button').classList.remove('disabled');
            }
        });
    });
}

// Add event listener for the custom event
window.addEventListener('setup-cart-forms', setupFormListeners);

// Now you can trigger the setup anywhere using:
// window.dispatchEvent(new CustomEvent('setup-cart-forms'));